module.exports = __webpack_public_path__ + "static/media/wide.1167f746.jpg";